module.exports = __webpack_public_path__ + "static/media/foreground_bushes.6a9765d1.svg";